import { create } from 'zustand'

const useSourceStore = create((set) => ({
    loading: null,
    setLoading: (value)=>set((state)=>({
        loading: value
    })),

    qrcode: null,
    setQrCode: (value)=>set((state)=>({
        qrcode: value
    })),

    background: null,
    setBackground: (value)=>set((state)=>({
        background: value
    })),

    riveComponent: null,
    setRiveComponent: (value)=>set((state)=>({
        riveComponent: value
    })),

    coinRiveComponent: null,
    setCoinRiveComponent: (value)=>set((state)=>({
        coinRiveComponent: value
    })),

    allLoaded: false,
    setAllLoaded: (value)=>set((state)=>({
        allLoaded: value
    })),

    taskBackground: false,
    setTaskBackground: (value)=>set((state)=>({
        taskBackground: value
    })),

    voucher: null, 
    setVoucher: (value)=>set((state)=>({
        voucher: value
    })),

    game: null,
    setGame: (value)=>set((state)=>({
        game: value
    })),

    achivement: null,
    setAchivement: (value)=>set((state)=>({
        achivement: value
    })),

    exchange: null,
    setExchange: (value)=>set((state)=>({
        exchange: value
    })),

    headerNight: null,
    setHeaderNight: (value)=>set((state)=>({
        headerNight: value
    })),

    leaders_timefilter: null,
    setLeaders_TimeFilter: (value)=>set((state)=>({
        leaders_timefilter: value
    })),

    miningBar: null,
    setMiningBar: (value)=>set((state)=>({
        miningBar: value
    })),

    history: null,
    setHistory: (value)=>set((state)=>({
        history: value
    })),

    messageBackgroundRed: null,
    setMessageBackgroundRed: (value)=>set((state)=>({
        messageBackgroundRed: value
    })),

    messageBackgroundPurple: null,
    setMessageBackgroundPurple: (value)=>set((state)=>({
        messageBackgroundPurple: value
    })),

    greenSection: null,
    setGreenSection: (value)=>set((state)=>({
        greenSection: value
    })),

    purpleSection: null,
    setPurpleSection: (value)=>set((state)=>({
        purpleSection: value
    })),

    messageOk: null,
    setMessageOk: (value)=>set((state)=>({
        messageOk: value
    })),

    messageError: null,
    setMessageError: (value)=>set((state)=>({
        messageError: value
    })),
    
    messageWin: null,
    setMessageWin:  (value)=>set((state)=>({
        messageWin: value
    })),

    onboardingImages: {
        hello: null,
        dc: null,
        mining: null,
        characters: null,
        fortune: null
    },

    setOnboardingImage: (key, value) => 
        set((state) => ({
            onboardingImages: {
                ...state.onboardingImages,
                [key]: value
            }
        })),

}))

export default useSourceStore